import React from 'react'
import { PAGE_SIZE } from '../../constants/pagination'
import styles from './index.module.scss'

interface PaginationProps {
    page: number
    totalItems: number
    onPageChange: (page: number) => void
}

interface PaginationArrowIconProps {
    direction: 'left' | 'right'
    double?: boolean
}

function PaginationArrowIcon({ direction, double = false }: PaginationArrowIconProps) {
    return (
        <svg
            className={direction === 'right' ? styles.pagination__arrowRight : undefined}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path d="M5 14L1 10L5 6" stroke="#202026" strokeWidth="1.44" strokeLinecap="round" strokeLinejoin="round" />
            {double && (
                <path d="M10 14L6 10L10 6" stroke="#202026" strokeWidth="1.44" strokeLinecap="round" strokeLinejoin="round" />
            )}
        </svg>
    )
}

export default function Pagination({
    page,
    totalItems,
    onPageChange,
}: PaginationProps) {
    if (totalItems <= PAGE_SIZE) return null

    const totalPages = Math.max(1, Math.ceil(totalItems / PAGE_SIZE))
    const safePage = Math.max(1, Math.min(page, totalPages))

    return (
        <nav className={styles.pagination} aria-label="Навигация по страницам">
            <div className={styles.pagination__summary}>
                <span>Всего страниц: {totalPages}</span>
            </div>
            <div className={styles.pagination__controls}>
                <div className={styles.pagination__arrowGroup}>
                    <button
                        type="button"
                        className={styles.pagination__arrowButton}
                        aria-label="Первая страница"
                        disabled={safePage === 1}
                        onClick={() => onPageChange(1)}
                    >
                        <PaginationArrowIcon direction="left" double />
                    </button>
                    <button
                        type="button"
                        className={styles.pagination__arrowButton}
                        aria-label="Предыдущая страница"
                        disabled={safePage === 1}
                        onClick={() => onPageChange(safePage - 1)}
                    >
                        <PaginationArrowIcon direction="left" />
                    </button>
                </div>
                <div className={styles.pagination__pages}>
                    <span
                        className={`${styles.pagination__pageButton} ${styles.pagination__active}`}
                        aria-current="page"
                        aria-label={`Текущая страница: ${safePage}`}
                    >
                        {safePage}
                    </span>
                </div>
                <div className={styles.pagination__arrowGroup}>
                    <button
                        type="button"
                        className={styles.pagination__arrowButton}
                        aria-label="Следующая страница"
                        disabled={safePage === totalPages}
                        onClick={() => onPageChange(safePage + 1)}
                    >
                        <PaginationArrowIcon direction="right" />
                    </button>
                    <button
                        type="button"
                        className={styles.pagination__arrowButton}
                        aria-label="Последняя страница"
                        disabled={safePage === totalPages}
                        onClick={() => onPageChange(totalPages)}
                    >
                        <PaginationArrowIcon direction="right" double />
                    </button>
                </div>
            </div>
        </nav>
    )
}
